import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {IconButton, Tooltip} from '@mui/material';
import {bool, func, string} from 'prop-types';
import React from 'react';

const VisibilityButton = ({
  onClick,
  isVisible,
  tooltipText,
  disabled,
  ...props
}) => {
  const adjustedButtonProps = {
    disabled: disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick,
    sx: {
      '&.Mui-disabled': {
        pointerEvents: 'auto',
      },
    },
  };

  return (
    <Tooltip title={tooltipText}>
      <IconButton
        size="small"
        color={isVisible ? 'primary' : 'default'}
        {...props}
        {...adjustedButtonProps}
      >
        {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </Tooltip>
  );
};

VisibilityButton.propTypes = {
  onClick: func,
  isVisible: bool,
  tooltipText: string,
  disabled: bool,
};

export default VisibilityButton;
